document.addEventListener('variantChangeEvent', (v) => {
    if(v?.detail?.variant?.id) {
        const allVariants = document.querySelectorAll('.pdp-specs-v5-specs-variant');
        const variantId = v.detail.variant.id;
        const targetElement = document.querySelector(`.pdp-specs-v5-specs-variant[variant_id="${variantId}"]`);
        if(!targetElement) return

        allVariants.forEach(element => {
            const isTarget = element.getAttribute('variant_id') === variantId.toString();
            element.classList.toggle('hidden', !isTarget);
        });
    }
});